import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ChatAppMessageProperties } from '../Models/ChatAppProperties';

import { ResponseToClient } from '../Models/OfflineNewProperties';

@Injectable({
  providedIn: 'root'
})
export class ChatAppService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  SaveMessage(chatForm: FormData): Observable<ResponseToClient> {
    return this.http.post<ResponseToClient>(this.baseUrl + '/ChatApp/SaveMessage', chatForm).pipe(
    map((response) => {
      return response;
    }), catchError(error => { return throwError(error); }));
}

  GetMessagesByUniqueIdWithAdapter(uniqueId, sender): Observable<ChatAppMessageProperties[]> {
    return this.http.get<ChatAppMessageProperties[]>(this.baseUrl + '/ChatApp/GetMessagesByUniqueIdWithAdapter/' + uniqueId + "/" + sender)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

}
